import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import * as vp from 'vopay';

const { Table, ProgressChart } = vp;

type AccountsOverviewProgressTableProps = {
  userData: {
    Statistics: {
      [Id: string]: {
        name: string;
        value: number;
      };
    };
  };
};

type StatusKeyValuePair = {
  name: string;
  value: number;
};

type FC = FunctionComponent<AccountsOverviewProgressTableProps>;

const AccountsOverviewProgressTable: FC = (props: AccountsOverviewProgressTableProps) => {
  const { userData } = props;
  const { t } = useTranslation('translations', { keyPrefix: 'HomePage.AccountOverviewProgressTable' });

  const tableProps: vp.TableProps = {
    name: 'accounts-overview-progress-table',
    variant: 'progress',
    hasNoHead: true,
    columns: {
      statusKey: { header: t('Table.statusKey', { defaultValue: 'Customer Name' }) },
      statusbar: { header: t('Table.statusbar', { defaultValue: 'Progress Chart' }) },
      value: { header: t('Table.value', { defaultValue: 'Value' }) },
    },
    rows: Object.values(userData.Statistics)
      .sort((a, b) => b.value - a.value)
      .map((user: StatusKeyValuePair) => ({
        statusKey: user.name,
        statusbar: (
          <ProgressChart
            variant="chart"
            backgroundColor={
              user.value >= 80
                ? 'rgba(0, 0, 0, 0.8)'
                : user.value >= 60
                  ? 'rgba(0, 0, 0, 0.6)'
                  : user.value >= 40
                    ? 'rgba(0, 0, 0, 0.4)'
                    : user.value >= 0
                      ? 'rgba(0, 0, 0, 0.2)'
                      : 'rgba(0, 0, 0, 0.2)'
            }
            percentComplete={user.value}
          />
        ),
        value: <div style={{ minWidth: 50 }}>{user.value}%</div>,
      })),
  };

  return <Table {...tableProps} />;
};

export default AccountsOverviewProgressTable;
